export default __webpack_public_path__ + "static/media/web-app.05404002.png";